import MultiSelect from "components/common/MultiSelect";
import { InfoAlert } from "features/practitioner/utils";
import React, { useEffect } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { Download } from "react-bootstrap-icons";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { GetAllPoyer } from "features/eliglibility/eligibility-check-list/config/eligibilityCheckListApi";
import BootDatePicker from "components/common/custom/forms/BootDatePicker";
import { GetInsuranceList } from "features/eliglibility/eliglibility-check/config/eligibilityCheckApi";
import ClaimExcelUpload from "./ClaimExcelUpload";
const ClaimUpload = ({ control, watch, setValue, errors, file, setFile }) => {
  const dispatch = useDispatch();
  const { insuranceList, relatedRelationShip } = useSelector(
    (state) => state.eligibilityCheck
  );
  useEffect(() => {
    if (insuranceList?.length === 0) {
      dispatch(GetInsuranceList());
    }
  }, [insuranceList]);
  // Handle template download
  const handleDownloadTemplate = () => {
    const link = document.createElement("a");
    link.href = `${process.env.PUBLIC_URL}/Eclaims_Import_Claims.xlsx`;
    link.download = "Eclaims_Import_Claims.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <Row>
      <Col xs={12}>
        <InfoAlert>
          Download the template, fill it with your data, select the payer and
          date then upload to begin the mapping process.
        </InfoAlert>
      </Col>
      <Row>
        <Col xs={12} md={6} xl={4}>
          <label className="form-label">
            Payer <span className="text-danger">*</span>{" "}
          </label>
          <Controller
            name="payer"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                options={insuranceList?.map((payer) => ({
                  value: payer.insurance_company_id,
                  code: payer.insurance_direct,
                  label:
                    payer.insurance_direct === 1
                      ? payer.payer_name
                      : `${payer.payer_name} - ${payer.insurance_shname}`,
                  original: payer, // Keep full object if needed
                }))}
                isClearable={true}
                placeholder="Choose..."
                onChange={(selected) => {
                  setValue(
                    "payer",
                    selected
                      ? {
                          payer_name: selected?.original?.payer_name,
                          insurance_company_id:
                            selected?.original.insurance_company_id,
                          insurance_direct: selected?.original.insurance_direct,
                          insurance_shname: selected?.original.insurance_shname,
                        }
                      : null
                  );
                }}
                value={
                  field.value
                    ? {
                        value: field.value.payer_id,
                        label:
                          field.value.insurance_direct === 1
                            ? field.value.payer_name
                            : `${field.value.payer_name} - ${field.value.insurance_shname}`,
                      }
                    : null
                }
              />
            )}
          />
          {errors.payer && (
            <div className="text-danger mt-1">Payer is required</div>
          )}
          <div className="mt-3">
            <BootDatePicker
              name="claim_date"
              label="Claim Date"
              control={control}
              errors={errors}
              isRequired={true}
              placeholder="MM-YYYY"
              onChange={(selected) => setValue("claim_date", selected)}
              rules={{ required: true }}
              showMonthYearPicker
            />
          </div>
        </Col>
        <Col xs={12} md={6} xl={4}>
          <Card className="mt-3">
            <Card.Body className="text-center d-flex flex-column justify-content-between h-100">
              <div>
                <div
                  className="rounded-circle bg-primary bg-opacity-10 text-primary d-flex align-items-center mb-3 justify-content-center mx-auto mb-3"
                  style={{ width: 80, height: 80 }}
                >
                  <Download size={28} />
                </div>
                <h5 className="fw-bold mb-2">Excel Template</h5>
                <p className="text-muted mb-4">
                  Download our preformatted Excel template to ensure your data
                  is structured correctly
                </p>
              </div>
              <div className=" d-flex justify-content-center">
                <Button
                  variant="primary"
                  className="d-flex align-items-center justify-content-center"
                  onClick={handleDownloadTemplate}
                >
                  Download Template
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} md={6} xl={4}>
          <ClaimExcelUpload
            watch={watch}
            control={control}
            setFile={setFile}
            file={file}
            setValue={setValue}
            errors={errors}
            name="excelFile"
          />
        </Col>
      </Row>
    </Row>
  );
};
export default ClaimUpload;
